import { render } from "./Counter.vue?vue&type=template&id=6d0e708c&scoped=true"
import script from "./Counter.vue?vue&type=script&lang=js"
export * from "./Counter.vue?vue&type=script&lang=js"

import "./Counter.vue?vue&type=style&index=0&id=6d0e708c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d0e708c"

export default script